/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricerules_Channels_LabelInputs */

const tr_landing_pricerules_channels_label = /** @type {(inputs: Landing_Pricerules_Channels_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildirim kanalları`)
};

const en_landing_pricerules_channels_label = /** @type {(inputs: Landing_Pricerules_Channels_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notification channels`)
};

const de_landing_pricerules_channels_label = /** @type {(inputs: Landing_Pricerules_Channels_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benachrichtigungskanäle`)
};

const ru_landing_pricerules_channels_label = /** @type {(inputs: Landing_Pricerules_Channels_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Каналы уведомлений`)
};

/**
* | output |
* | --- |
* | "Notification channels" |
*
* @param {Landing_Pricerules_Channels_LabelInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_pricerules_channels_label = /** @type {((inputs?: Landing_Pricerules_Channels_LabelInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricerules_Channels_LabelInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricerules_channels_label(inputs)
	if (locale === "de") return de_landing_pricerules_channels_label(inputs)
	if (locale === "ru") return ru_landing_pricerules_channels_label(inputs)
	return tr_landing_pricerules_channels_label(inputs)
});